"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UIFloatingButtonGroup = _interopRequireDefault(require("UIComponents/button/UIFloatingButtonGroup"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _utils = require("composer-plugins/lib/utils");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _FileManager = _interopRequireDefault(require("composer-lib/components/shared/FileManager"));

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _userInfo = require("hub-http/userInfo");

var _Constants = require("FileManagerLib/Constants");

var _FileAccess = require("FileManagerLib/enums/FileAccess");

var _hubLVideo = require("FileManagerLib/utils/hubLVideo");

var _constants = require("composer-plugins/lib/constants");

var _VideoContainer = _interopRequireDefault(require("composer-plugins/plugins/video/VideoContainer"));

var _VideoComponent = _interopRequireDefault(require("composer-plugins/plugins/video/VideoComponent"));

var VIDEO_OPTIONS_MENU_CLASSNAME = 'video-component-options';
var EditableVideoComponent = (0, _createReactClass.default)({
  displayName: "EditableVideoComponent",
  propTypes: {
    block: _propTypes.default.object.isRequired,
    blockProps: _propTypes.default.object.isRequired,
    showLoadingOverlay: _propTypes.default.bool.isRequired,
    videoFound: _propTypes.default.bool.isRequired,
    vidyardURL: _propTypes.default.string,
    nativeURL: _propTypes.default.string,
    getVideo: _propTypes.default.func.isRequired,
    onVideoLoad: _propTypes.default.func.isRequired
  },
  contextTypes: {
    getEditorState: _propTypes.default.func.isRequired,
    getReadOnly: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      openFileManager: false,
      showActionButtons: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var blockProps = this.props.blockProps;
    this.FileManager = (0, _FileManager.default)(blockProps.fileManagerUploadedFileAccess, (0, _UsageTracking.getUsageTracker)());
  },
  componentDidMount: function componentDidMount() {
    this.props.blockProps.onInsertableLoaded();
    document.body.addEventListener('click', this.handleHideActions);
    this.addVideoAttributes();
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var getCommentsOnly = nextProps.blockProps.getCommentsOnly;
    var getReadOnly = this.context.getReadOnly;
    return nextProps.nativeURL !== this.props.nativeURL || nextProps.vidyardURL !== this.props.vidyardURL || nextProps.showLoadingOverlay !== this.props.showLoadingOverlay || nextState.showActionButtons !== this.state.showActionButtons || !getReadOnly() && !getCommentsOnly();
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.handleHideActions);
  },
  addVideoAttributes: function addVideoAttributes() {
    if (this._container && this._container.src === this.props.nativeURL) {
      this._container.onload = this.hideOverlay();
    }
  },
  handleShowActions: function handleShowActions() {
    this.setState({
      showActionButtons: true
    });
  },
  handleOpenFileManager: function handleOpenFileManager() {
    this.setState({
      openFileManager: true,
      showActionButtons: false
    });
  },
  handleCloseFileManager: function handleCloseFileManager() {
    this.setState({
      openFileManager: false
    });
  },
  handleHideActions: function handleHideActions(e) {
    var target = e.toElement || e.relatedTarget;

    if ((0, _utils.targetIsOrContainedByEl)("." + _constants.VIDEO_COMPONENT_CLASSNAME, target) || (0, _utils.targetIsOrContainedByEl)("." + VIDEO_OPTIONS_MENU_CLASSNAME, target)) {
      return;
    }

    this.setState({
      showActionButtons: false
    });
  },
  handleReplaceVideo: function handleReplaceVideo(file) {
    var block = this.props.block;
    var key = block.getEntityAt(0);
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;
    var playerId = (0, _hubLVideo.getHubLVideoPlayerIdFromFile)(file.toJS());
    var src = file.get('url');
    this.handleCloseFileManager();
    onChange((0, _draftHelpers.updateEntity)(key, getEditorState(), {
      playerId: playerId,
      src: src
    }));
    this.props.getVideo(playerId, src);
  },
  handleRemoveVideo: function handleRemoveVideo(evt) {
    var block = this.props.block;

    if (evt) {
      // stop click from propagating up to BodyEditor: it causes internal
      // Draft blur/focus handling to run which generates onChange events
      // with stale editorStates which overwrite our updates below
      evt.stopPropagation();
    }

    var key = block.getEntityAt(0);
    var _this$context2 = this.context,
        getEditorState = _this$context2.getEditorState,
        onChange = _this$context2.onChange;
    onChange((0, _draftHelpers.deleteEntity)(key, getEditorState()));
  },
  attachOnLoadEvent: function attachOnLoadEvent() {},
  renderFileManager: function renderFileManager() {
    var blockProps = this.props.blockProps;
    var fileManagerUploadedFileAccess = blockProps.fileManagerUploadedFileAccess;

    if (!this.state.openFileManager) {
      return null;
    }

    var drawerType = fileManagerUploadedFileAccess === _FileAccess.DrawerFileAccess.VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE ? _Constants.DrawerTypes.VIDEO : _Constants.DrawerTypes.HUBL_VIDEO;
    return _react.default.createElement(this.FileManager, {
      auth: (0, _userInfo.userInfoSync)()
    }, _react.default.createElement(_Drawer.default, {
      type: drawerType,
      onSelect: this.handleReplaceVideo,
      onClose: this.handleCloseFileManager
    }));
  },
  renderOptionButtons: function renderOptionButtons() {
    var _this = this;

    var _this$props = this.props,
        showLoadingOverlay = _this$props.showLoadingOverlay,
        videoFound = _this$props.videoFound,
        vidyardURL = _this$props.vidyardURL,
        nativeURL = _this$props.nativeURL;
    var showActionButtons = this.state.showActionButtons;
    return _react.default.createElement(_UIFloatingButtonGroup.default, {
      buttonGroup: _react.default.createElement(_UIButtonGroup.default, {
        className: VIDEO_OPTIONS_MENU_CLASSNAME,
        onMouseLeave: this.handleHideActions
      }, _react.default.createElement(_UIButton.default, {
        onClick: this.handleOpenFileManager,
        size: "extra-small",
        use: "tertiary"
      }, _react.default.createElement(_UIIcon.default, {
        name: "replace"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "composer-lib.videoPlugin.buttons.edit"
      })), _react.default.createElement(_UIButton.default, {
        onClick: this.handleRemoveVideo,
        size: "extra-small",
        use: "tertiary"
      }, _react.default.createElement(_UIIcon.default, {
        name: "delete"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "composer-lib.videoPlugin.buttons.delete"
      }))),
      open: showActionButtons
    }, _react.default.createElement(_VideoComponent.default, {
      showLoadingOverlay: showLoadingOverlay,
      showActionButtons: showActionButtons,
      videoFound: videoFound,
      vidyardURL: vidyardURL,
      nativeURL: nativeURL,
      videoFef: function videoFef(c) {
        return _this._container = c;
      },
      onMouseEnter: this.handleShowActions,
      onMouseLeave: this.handleHideActions,
      onVideoLoad: this.props.onVideoLoad
    }));
  },
  render: function render() {
    var block = this.props.block;
    var key = block.getEntityAt(0);

    if (!key) {
      return null;
    }

    return _react.default.createElement("div", null, this.renderFileManager(), this.renderOptionButtons());
  }
});

var _default = (0, _VideoContainer.default)(EditableVideoComponent);

exports.default = _default;
module.exports = exports.default;